/**
 * @desc 查询Cino信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.CustomsInfosResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cino/byUniqueCinoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
